import React from "react";

interface PaginationProps {
  page: number;
  totalPages: number;
  setPage: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({ page, totalPages, setPage }) => {
  if (totalPages <= 1) return null;

  const getPages = () => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      if (page <= 4) {
        pages.push(1, 2, 3, 4, 5, "...", totalPages);
      } else if (page >= totalPages - 3) {
        pages.push(1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        pages.push(1, "...", page - 1, page, page + 1, "...", totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="flex items-center space-x-1">
      <button
        onClick={() => setPage(1)}
        disabled={page === 1}
        className="px-2 py-1 text-gray-500 bg-white border rounded disabled:opacity-50"
      >
        &laquo;
      </button>
      <button
        onClick={() => setPage(page - 1)}
        disabled={page === 1}
        className="px-2 py-1 text-gray-500 bg-white border rounded disabled:opacity-50"
      >
        &lsaquo;
      </button>
      {getPages().map((p, idx) =>
        p === "..." ? (
          <span key={idx} className="px-2 py-1 text-gray-500">
            ...
          </span>
        ) : (
          <button
            key={p}
            onClick={() => setPage(Number(p))}
            className={`px-2 py-1 border rounded ${page === p ? "bg-blue-600 text-white" : "bg-white text-gray-700"}`}
          >
            {p}
          </button>
        )
      )}
      <button
        onClick={() => setPage(page + 1)}
        disabled={page === totalPages}
        className="px-2 py-1 text-gray-500 bg-white border rounded disabled:opacity-50"
      >
        &rsaquo;
      </button>
      <button
        onClick={() => setPage(totalPages)}
        disabled={page === totalPages}
        className="px-2 py-1 text-gray-500 bg-white border rounded disabled:opacity-50"
      >
        &raquo;
      </button>
    </div>
  );
};

export default Pagination;